<template>
  <div class="sion-login-container">
    <div class="sion-login-signin">
      <cube-form>
        <cube-form-group>
          <div class="sign-box">
            <div class="sign-input">
              <cube-input
                type="number"
                v-model="siginInfo.passward"
                placeholder="请输入新密码"
              ></cube-input>
            </div>
          </div>
        </cube-form-group>
        <cube-form-group>
          <div class="sign-box">
            <div class="sign-input">
              <cube-input
                v-model="siginInfo.phone"
                type="number"
                :clearable="true"
                placeholder="请输入手机号"
              ></cube-input>
            </div>
            <div
              class="sign-label"
              style="width: 33%; font-size: 14px; textalign: right"
            >
              <label for>
                <span v-if="waiting" @click="getCheck">获取验证码</span>
                <span v-else class="react">重新获取({{ time }})</span>
              </label>
            </div>
          </div>
        </cube-form-group>
        <cube-form-group>
          <div class="sign-box">
            <div class="sign-input">
              <cube-input
                type="number"
                v-model="siginInfo.checkNum"
                placeholder="请输入验证码"
              ></cube-input>
            </div>
          </div>
        </cube-form-group>
      </cube-form>
    </div>
    <cube-form-group>
      <cube-button @click="complete">重置密码</cube-button>
      <div class="sion-btn" @click="out">取消</div>
    </cube-form-group>
  </div>
</template>
<script type="text/ecmascript-6">
import { toast } from "@/common/api/api.js";
import { getStaffPhoneSign,updatePassword } from "@/common/api";
export default {
  data() {
    return {
      siginInfo: {
        passward: "",
        phone: "",
        checkNum: ""
      },
      time: 60,
      waiting: true,
      eye: {
        open: false,
        reverse: false
      }
    };
  },
  watch: {
    siginInfo: {
      deep: true,
      handler: value => {
        if (value.passward && value.passwardAgain) {
          value.disabled = false;
        }
      }
    }
  },
  created () {
    console.log("forgetPages")
  },
  methods: {
    complete() {
      if (this.siginInfo.passward.length < 6) {
        toast(this, "密码不能少于六位", "error");
        return;
      }
      updatePassword({
        passWord: this.siginInfo.passward,
        flag:1,
        signCode:this.siginInfo.checkNum,
        phone:this.siginInfo.phone
      }).then(res => {
        if (res.code == 200) {
          toast(this, res.message, "");
          setTimeout(() => {
            this.$router.go(-1);
          }, 2000);
        } else {
          toast(this, res.message, "error");
        }
      });
    },
    out() {
      this.$router.go(-1);
    },
    getCheck() {
      let self = this
      let phoneReg = new RegExp(/^[1][3,4,5,6,7,8,9][0-9]{9}$/);
      if (!phoneReg.test(this.siginInfo.phone)) {
        toast(this, "请输入正确手机号", "error");
        return;
      }
      getStaffPhoneSign({
        phone: this.siginInfo.phone,
        flag: 1
      }).then(res => {
        if (res.code == 200) {
          this.time = 60;
          this.waiting = false;
          var self = this;
          let timeout = setInterval(function() {
            self.time--;
            if (self.time == 0) {
              self.waiting = true;
              window.clearTimeout(timeout);
            }
          }, 1000);
        } else {
          toast(this, res.message, "error");
        }
      });
    }
  }
};
</script>
<style lang="stylus" type="stylesheet/stylus">
@import '../../assets/stylus/index.styl';
</style>
